import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_PRIMITIVE__bool } from '../../_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD__tensor_image_mask_boolean } from '../../_fields/_tensor/FIELD__tensor_image_mask_boolean';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION__image_mask_boolean_to_tensor extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_IMAGE__MASK_BOOLEAN_TO_TENSOR;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input({ category: ENUM__image_asset_category.MASK })
  image_mask!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input({ value: CONSTANTS.COLOR.get_average(0), values_allowed: CONSTANTS.COLOR, value_range: CONSTANTS.COLOR })
  cutoff!: FIELD_PRIMITIVE__int;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false })
  invert!: FIELD_PRIMITIVE__bool;

  /*
   * OUTPUT
   */

  @FIELD__tensor_image_mask_boolean.init_as_output()
  out__tensor_mask!: FIELD__tensor_image_mask_boolean;

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.IMAGE__MASK_TO_TENSOR_IMAGE_MASK_BOOLEAN);
  }
}
